/**
 * MASTERCASE — Custom Properties Bridge
 * Validates, injects properties, attaches files.
 * Shows a loading spinner overlay when a file upload is in progress.
 */
(function () {
  'use strict';

  /* ── Loading overlay (injected once, shown/hidden as needed) ── */
  var overlay = null;

  function createOverlay() {
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.id = 'mc-loading';
    overlay.innerHTML = [
      '<style>',
      '#mc-loading{display:none;position:fixed;inset:0;z-index:99999;background:rgba(255,255,255,.75);',
      'align-items:center;justify-content:center;flex-direction:column;gap:.8rem}',
      '#mc-loading.on{display:flex}',
      '#mc-loading .mc-spin{width:36px;height:36px;border:3px solid #e0e0e0;border-top-color:#000;',
      'border-radius:50%;animation:mc-r .7s linear infinite}',
      '@keyframes mc-r{to{transform:rotate(360deg)}}',
      '#mc-loading .mc-txt{font-size:.9rem;color:#333;font-weight:500}',
      '</style>',
      '<div class="mc-spin"></div>',
      '<span class="mc-txt">Envoi de votre image…</span>'
    ].join('');
    document.body.appendChild(overlay);
  }

  function showLoader() { createOverlay(); overlay.classList.add('on'); }
  function hideLoader() { if (overlay) overlay.classList.remove('on'); }

  /* ── Fetch interceptor ── */
  var _fetch = window.fetch;

  window.fetch = function () {
    var url = arguments[0];
    var opts = arguments[1];

    try {
      var u = typeof url === 'string' ? url : (url && url.url ? url.url : '');

      if (u.indexOf('/cart/add') !== -1 && opts && opts.body instanceof FormData) {

        /* Validate required fields */
        var required = document.querySelectorAll('.mc-custom-property[required]');
        for (var i = 0; i < required.length; i++) {
          var field = required[i];
          var val = (field.value || '').trim();
          if (!val) {
            var name = field.getAttribute('data-property-name') || '';
            var btnId = (field.id || '').replace('hidden', 'btn');
            var trigger = document.getElementById(btnId);
            var target = trigger || field;
            target.style.borderColor = '#c00';
            target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            document.querySelectorAll('add-to-cart-component').forEach(function (c) {
              var btn = c.querySelector('button');
              if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
            });
            setTimeout(function () { alert('Veuillez remplir : ' + name); }, 50);
            return Promise.resolve(new Response(
              JSON.stringify({ status: 422, message: 'Champ requis manquant: ' + name, description: 'Champ requis manquant: ' + name }),
              { status: 422, headers: { 'Content-Type': 'application/json' } }
            ));
          }
        }

        /* Inject custom properties */
        var all = document.querySelectorAll('.mc-custom-property');
        for (var j = 0; j < all.length; j++) {
          var fname = all[j].getAttribute('data-property-name');
          var fval = (all[j].value || '').trim();
          if (fname && fval) opts.body.set('properties[' + fname + ']', fval);
        }

        /* Attach file + show loader if file present */
        var hasFile = false;
        var fi = document.querySelector('.mc-file-input');
        if (fi && fi.files && fi.files.length) {
          opts.body.set('properties[_image_file]', fi.files[0]);
          hasFile = true;
        }

        if (hasFile) {
          showLoader();
          return _fetch.apply(this, arguments).then(function (response) {
            hideLoader();
            return response;
          }).catch(function (err) {
            hideLoader();
            throw err;
          });
        }
      }
    } catch (ex) {
      console.error('[MC Properties]', ex);
      hideLoader();
    }

    return _fetch.apply(this, arguments);
  };
})();
